export default __webpack_public_path__ + "static/dev-next-bellwood-fbf0e9c30fe52b39cbc5e1bbaaebdfd6.jpg";